import { isEmpty } from 'bold-ui'

import { PassouFalhouEnum } from '../../enums-consultaSeguimento'
import {
  hasAnySim,
  isAllNao,
  isPerguntaOutroFilled,
  isPerguntaOutroNao,
  isPerguntaOutroSim,
} from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta03ExemplosEnum,
  ConsultaSeguimentoPergunta03Model,
} from './model-consultaSeguimentoPergunta03'

const pergunta03ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta03ExemplosEnum)

export function isPergunta03ExemplosAllNao(value: ConsultaSeguimentoPergunta03Model): boolean {
  const isExemplosAllNao = isAllNao(value?.PERGUNTA_03_EXEMPLOS, pergunta03ExemplosEnumValues)

  if (isPerguntaOutroFilled(value?.OUTRO)) {
    return isExemplosAllNao && isPerguntaOutroNao(value?.OUTRO)
  }

  return isExemplosAllNao
}

export function hasPergunta03ExemplosAnySim(value: ConsultaSeguimentoPergunta03Model): boolean {
  return hasAnySim(value?.PERGUNTA_03_EXEMPLOS) || isPerguntaOutroSim(value?.OUTRO)
}

export function prunePergunta03(value: ConsultaSeguimentoPergunta03Model): ConsultaSeguimentoPergunta03Model {
  return value
}

export function conditionToCalculatePergunta03(values: ConsultaSeguimentoPergunta03Model): boolean {
  return (
    !isEmpty(values.PERGUNTA_03_HEADER) && (hasPergunta03ExemplosAnySim(values) || isPergunta03ExemplosAllNao(values))
  )
}

export function calculateResultadoPergunta03(values: ConsultaSeguimentoPergunta03Model): PassouFalhouEnum | undefined {
  if (!isEmpty(values.PERGUNTA_03_HEADER) && hasPergunta03ExemplosAnySim(values)) {
    return PassouFalhouEnum.PASSOU
  }
  if (!isEmpty(values.PERGUNTA_03_HEADER) && isPergunta03ExemplosAllNao(values)) {
    return PassouFalhouEnum.FALHOU
  }
}
